export default __webpack_public_path__ + "static/media/slide4.5f5558a8.webp";